export enum CONTENT_PREVIEW {
    /**
     * @value Preview unavailable
     */
    PREVIEW_UNAVAILABLE = 'CONTENT_PREVIEW.PREVIEW_UNAVAILABLE',
    /**
     * @value Widgets that are not compatible with NGI are not supported in the preview. This content contains at least one widget that is not compatible with NGI.
     */
    PREVIEW_UNAVAILABLE_DESCRIPTION = 'CONTENT_PREVIEW.PREVIEW_UNAVAILABLE_DESCRIPTION',
}
